var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeat3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    fill: "currentColor",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.333333 298.666667a106.666667 106.666667 0 1 0 0-213.333334 106.666667 106.666667 0 0 0 0 213.333334z m327.573334 237.354666h-161.749334l-46.976-141.653333c-27.733333-120.021333-200.106667-84.394667-181.44 33.024l54.442667 155.946667c8.213333 40.170667 38.826667 74.112 91.008 74.112h208.533333v201.877333c0 76.906667 113.941333 77.290667 113.941334 1.365333V613.76c0-37.162667-26.645333-77.717333-77.76-77.717333z m-113.898667 148.864H488.96c-77.482667 0-77.482667-13.184-107.285333-88.064-24.576-61.781333-91.946667-229.376-91.946667-229.376-21.056-45.781333-85.056-16.021333-72.213333 23.488l87.936 232.597334C353.706667 751.146667 353.472 768 463.232 768h156.522667c55.424 0 55.701333-83.114667-0.746667-83.114667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat3);
export default __webpack_public_path__ + "static/media/seat-3.dcc157261cb0d0f826bfd10d21a9bcdd.svg";
export { ForwardRef as ReactComponent };